@import (reference) '../../../constants/spacing.module.less';
@import (reference) '../../style.module.less';

.date-pickers-container {
  display: flex;
  flex-direction: column;
}

.date-picker {
  border: 1px solid var(--left-nav--advanced-search-filter--date-picker-border-color);
  border-radius: 4px;
  height: 32px;
  padding-bottom: 0;
  margin-bottom: @space-8;
  @input-states();
  @input-text();

  input {
    border: none;
    &::placeholder {
      color: var(--left-nav--advanced-search-filter--input-placeholder-color);
    }

    &:active,
    &:active:hover,
    &:hover {
      border: none;
    }
  }

  button {
    border: none;
    border-radius: 4px;
    height: 30px;
    background-color: transparent;

    svg {
      width: 24px;
      fill: var(--left-nav--advanced-search-filter--date-picker-icon-color);
    }

    &:active,
    &:active:hover,
    &:hover {
      border: none;
      box-shadow: none;
    }
  }
}

.from-date-picker {
  padding-bottom: 10px;
}
